export var ViewOperationType;
(function (ViewOperationType) {
    /**
     * 切换画面
     */
    ViewOperationType[ViewOperationType["ToggleView"] = 0] = "ToggleView";
    /**
     * 弹出画面
     */
    ViewOperationType[ViewOperationType["PopupView"] = 1] = "PopupView";
    /**
     * 关闭画面
     */
    ViewOperationType[ViewOperationType["CloseView"] = 2] = "CloseView";
    /**
     * 控制页面
     */
    ViewOperationType[ViewOperationType["ControlView"] = 3] = "ControlView";
})(ViewOperationType || (ViewOperationType = {}));
